module.exports = __webpack_public_path__ + "static/media/git_color.66231354.png";